import { Map } from 'immutable';
import ActionTypes from './simulationInstanceActions';
import { Path } from './simulationInstanceSelectors';

export default function(state=Map(), action) {
    switch(action.type) {
        case ActionTypes.RECEIVE_FORM_FIELDS:
            return handleReceiveFormFields(state, action);
        case ActionTypes.RECEIVE_INITIAL_VALUES:
            return handleReceiveInitialValues(state, action);
        case ActionTypes.CLEAR_INITIAL_VALUES:
            return handleClearInitialValues(state);
        case ActionTypes.CLEAR_FORM_FIELDS:
            return handleClearFormFields(state);
    }
    return state;
}

function handleReceiveFormFields(state, action) {
    return state.setIn(Path.SIMULATION_INSTANCE_FORMFIELDS, action.result);
}

function handleReceiveInitialValues(state, action) {
    return state.setIn(Path.SIMULATION_INSTANCE_INITIALVALUES, action.result);
}

function handleClearInitialValues(state) {
    return state.delete(Path.SIMULATION_INSTANCE_INITIALVALUES[0]);
}

function handleClearFormFields(state) {
    return state.delete(Path.SIMULATION_INSTANCE_FORMFIELDS[0]);
}